import React from 'react';
import ReactSlick from 'react-slick';
import PropTypes from 'prop-types';
import SliderItemTestimonials from 'modules/blocks/slider/sliderItemTestimonials';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {withRouter} from 'react-router-dom';

const SliderItems = {
  testimonials: SliderItemTestimonials
};

@withRouter
export default class Slider extends React.Component {
  static propTypes = {
    collection       : PropTypes.array,
    type             : PropTypes.string,
    reactSlickOptions: PropTypes.object
  };

  static defaultProps = {
    collection       : [],
    type             : '',
    reactSlickOptions: {
      dots          : false,
      fade          : true,
      arrows        : true,
      infinite      : true,
      autoplay      : true,
      autoplaySpeed : 10000,
      accessibility : true,
      speed         : 1200,
      slidesToShow  : 3,
      slidesToScroll: 3
    }
  };

  render() {
    const {
      collection,
      type,
      reactSlickOptions
    } = this.props;
    const SliderItem = SliderItems[this.props.type];

    let sliderComponents;

    switch (type) {
      case 'testimonials': {
        sliderComponents = collection.map((element, index) => (
          <div key={`element-${index}`}>
            <SliderItem {...element} />
          </div>)
        );

        break;
      }

      default: {
        sliderComponents = collection.map((element, index) => (<div
            key={`element-${index}`}
          >
            <SliderItem {...element} />
          </div>)
        );

        break;
      }
    }

    return (<div className="slider-content">
      <ReactSlick
        {...reactSlickOptions}
      >
        {
          sliderComponents
        }
      </ReactSlick>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/blocks/slider/index.js